module.exports = __webpack_public_path__ + "img/ruoyi11.1ac7cde4.png";